import React from 'react';
import { IIconProps } from '../interfaces';
import { useTheme } from '@chakra-ui/react';

const AleaDownloadIcon: React.FC<IIconProps> = ({
  color,
  size = '23',
}) => {
  const theme = useTheme();
  const iconColor = color || theme.colors.alea[500];
  const width = parseInt(String(size), 10);
  const height = (23 / 23) * width;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.97559 16.5078V19.0743C1.97559 20.3094 2.97676 21.3105 4.21178 21.3105H18.9503C20.1853 21.3105 21.1865 20.3094 21.1865 19.0743V16.5078"
        stroke={iconColor}
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M12.0225 1.69238C12.0225 1.1401 11.5747 0.692383 11.0225 0.692383C10.4702 0.692383 10.0225 1.1401 10.0225 1.69238L12.0225 1.69238ZM10.3154 18.0528C10.7059 18.4433 11.339 18.4433 11.7296 18.0528L18.0935 11.6889C18.4841 11.2983 18.4841 10.6652 18.0935 10.2746C17.703 9.88412 17.0698 9.88412 16.6793 10.2746L11.0225 15.9315L5.36561 10.2746C4.97508 9.88412 4.34192 9.88412 3.95139 10.2746C3.56087 10.6652 3.56087 11.2983 3.95139 11.6889L10.3154 18.0528ZM11.0225 1.69238L10.0225 1.69238L10.0225 17.3457L11.0225 17.3457L12.0225 17.3457L12.0225 1.69238L11.0225 1.69238Z"
        fill={iconColor}
      />
    </svg>
  );
};

export default AleaDownloadIcon;
